<template>
	<div>
		<h3>商品管理</h3>
		<div class="table">
        <div style="width: 100%;height: 50px;">
          <div class="block">
            <span class="demonstration">产品名：</span>
            <el-input style='width: 200px;' v-model="name" type="text" placeholder="产品名"></el-input>
          </div>

          <div class="block" style="margin-left:25px">
            <span class="demonstration">组编号：</span>
            <el-select v-model="productGroup" placeholder="请选择" size='small' clearable>
              <el-option v-for="item in productGrouplist"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code" ></el-option>
            </el-select>
            <el-button style="margin-left:25px" type="primary" @click='searchFun' size='small'>搜索</el-button>
          </div>
        </div>
			<el-table :data="tableData4" style="width: 100%" height='calc(100vh - 300px)' border>
				<el-table-column prop="id" label="产品ID"></el-table-column>
        <el-table-column prop="name" label="产品名称"></el-table-column>
        <el-table-column label="费用">
          <template slot-scope="scope">
              <span v-if="scope.row.productLevel == 2">
              <p v-if="scope.row.mainProductJsonpriceModel == 3" style="color: rgb(153, 153, 153);text-align: left;" class="text"><b><span class="yellow">{{ (scope.row.productPlanInfoamount * (scope.row.suggestPrice /100) ) / 100}}元</span></b></p>
              <p v-else style="color: rgb(153, 153, 153);text-align: left;" class="text"><b><span class="yellow">{{scope.row.suggestPrice/100}}元</span></b></p>
              </span>
              <span v-else>
              <p style="color: rgb(153, 153, 153);text-align: left;" class="text"><b><span class="yellow">{{scope.row.suggestPrice/100}}元</span></b></p>
              </span>
					</template>
        </el-table-column>
        <el-table-column label="保障日期">
          <template slot-scope="scope">
          
                <span v-if="scope.row.productLevel == 2">
                  <span v-if="scope.row.mainProductJsonpriceModel == 3">
                    <p class="text" style="color:#999999;text-align: left;">{{scope.row.productPlanInfovalidStart}}
                    <span v-if="scope.row.productPlanInfovalidType == 2">月</span>
                    <span v-if="scope.row.productPlanInfovalidType == 1">年</span>
                    <span v-if="scope.row.productPlanInfovalidType == 3">日</span>
                  </p>
                </span>
                <span v-else>
                    <p class="text" style="color:#999999;text-align: left;">{{scope.row.mainProductJsonperiod}}
                    <span v-if="scope.row.mainProductJsonperiodType == 2">月</span>
                    <span v-if="scope.row.mainProductJsonperiodType == 1">年</span>
                    <span v-if="scope.row.mainProductJsonperiodType == 3">日</span>
                  </p>
                </span>
                </span>
                  <span v-else>
                    <p class="text" style="color:#999999;text-align: left;">{{scope.row.period}}
                    <span v-if="scope.row.periodType == 2">月</span>
                    <span v-if="scope.row.periodType == 1">年</span>
                    <span v-if="scope.row.periodType == 3">日</span>
                  </p>
                </span>
					</template>
        </el-table-column>
				<el-table-column label="操作" align='center'>
					<template slot-scope="scope">
						<template>
							<el-button type="text" @click="pause(scope.row)">暂停</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
	import {productList,cancelContractTravel,listProductConfig } from '@/axios/api.js'
	export default {
		data() {
			return {
				tableData: [],
				tableData4: [],
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:0,//当前页		
        productGroup:"",
        name:''	,
        productGrouplist:[]
			}
		},
		methods: {
      searchFun() {
        this.eachPage = 10; //每页
        this.indexPage = 0; //当前页
         this.getData()
      },
      pause(row) {
        console.log(row.id)
        var data={
				channelId:localStorage.getItem('channelId'),
				productId:row.id
			}
			cancelContractTravel(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.$message({
							showClose: true,
							message: '已解约',
							type: 'success'
						});
						this.getData();
					}
				})
				.catch(err => {
					console.log(err)
				})	
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.eachPage = val;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.indexPage = (val - 1) * this.eachPage;
        this.getData();
      },
      
			getData(){
				var data={
					start:this.indexPage,
					count:this.eachPage,
          productGroup: this.productGroup,
          name:this.name
				}
				productList(data)
				.then( res => {
					if(res.data.code == 0){
						this.tableData4=res.data.obj
						this.allpage=res.data.total;
						// this.handleSizeChange(this.eachPage);
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
		
		},
		mounted() {
			this.getData()
      var obj = {
        type:1, //1产品组 2产品分类 3职业类别 4清单类型
        start: 0,
        count: 100
      }
      listProductConfig(obj).then((res)=>{
        this.productGrouplist = res.data.obj2.groupLst
        console.log(res)
      })
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}

	.table {
		margin-top: 20px;
	}

	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}

	.fenye .pagination {
		float: right;
	}
  .block {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/goods.vue